import React, { useEffect, useRef } from 'react';
import useMagnetic from '../hooks/useMagnetic';
import HeroPlanet from './HeroPlanet';

const PARALLAX_FACTORS = [0.06, -0.04, 0.05];

export default function Hero() {
  const lineRef0 = useRef(null);
  const lineRef1 = useRef(null);
  const lineRef2 = useRef(null);

  useEffect(() => {
    const lineRefs = [lineRef0, lineRef1, lineRef2];
    const onScroll = () => {
      const y = window.scrollY;
      lineRefs.forEach((r, i) => {
        if (r.current) r.current.style.transform = `translate3d(${y * PARALLAX_FACTORS[i]}px, ${y * PARALLAX_FACTORS[i] * 0.3}px, 0)`;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const btnWork = useMagnetic();
  const btnHire = useMagnetic();

  return (
    <section id="top" className="hero">
      <div className="hero-glow" />
      <div className="container-x hero-row">
        <div className="hero-content">
          <div className="hero-meta">
            <div className="kind">
              <div><span className="micro">Role</span><span className="v">Full-Stack · Cybersec</span></div>
              <div><span className="micro">Based</span><span className="v">Montpellier / FR</span></div>
              <div>
                <span className="micro">Status</span>
                <span className="hero-status"><span className="pulse" />Open to opportunities</span>
              </div>
            </div>
          </div>
          <h1 className="hero-title">
            <span className="row"><span ref={lineRef0}>Raphaël</span></span>
            <span className="row"><span ref={lineRef1}>Be<span style={{letterSpacing: '-0.001em'}}>r</span>taina-</span></span>
            <span className="row"><span ref={lineRef2}><em>Loichemol.</em></span></span>
          </h1>
          <div className="hero-sub">
            <p className="hero-statement">
              I build <strong>trust at the lowest level of the stack</strong> — from <span className="hl">cybersecurity pentests</span> and OpenGL engines to React products that actually feel good to use.
              Curious, hands-on, and unreasonably interested in how things work underneath.
            </p>
            <div className="hero-ctas">
              <a href="#work" ref={btnWork} className="btn primary">
                <span className="label">See selected work</span>
                <svg className="arrow" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M2 7h10M8 3l4 4-4 4" /></svg>
              </a>
              <a href="#contact" ref={btnHire} className="btn ghost">
                <span className="label">Hire me</span>
              </a>
            </div>
          </div>
        </div>
        <HeroPlanet />
      </div>
    </section>
  );
}
